import { staticURL } from "../Utilities";

export const birthdayCelebration = staticURL("/images/birthday-celebration.png");
export const contractSignature = staticURL("/images/contract-signature.png");
export const reportCardGraphic = staticURL("/images/report-card-graphic.svg");
export const reportCardIBLearnerProfile = staticURL("/images/report-card-ib-learner-profile.png");
export const reportCardIEYCLogo = staticURL("/images/report-card-ieyc-logo.png");
export const reportCardIMYCLogo = staticURL("/images/report-card-imyc-logo.png");
export const reportCardPersonalLearningGoals = staticURL("/images/report-card-personal-learning-goals.png");
export const reportCardPrimarySignature = staticURL("/images/report-card-primary-signature.png");
export const reportCardSecondarySignature = staticURL("/images/report-card-secondary-signature.png");
export const schoolScenery1 = staticURL("/images/school-scenery-1.png");
export const studentBoy1 = staticURL("/images/student-boy-1.svg");
export const studentBoy2 = staticURL("/images/student-boy-2.svg");
export const studentGirl1 = staticURL("/images/student-girl-1.svg");
export const verita4AllStamp = staticURL("/images/verita-4-all-stamp.png");
export const veritaLogoAndWordmark = staticURL("/images/verita-logo-and-wordmark.png");
export const veritaPortalLogoAndWordmark = staticURL("/images/verita-portal-logo-and-wordmark.png");
export const veritaWingsSymmetricMedium = staticURL("/images/verita-wings-symmetric-medium.png");
export const veritaWingsSymmetricMediumWhite = staticURL("/images/verita-wings-symmetric-medium-white.png");
export const veritaWingsSymmetricSmall = staticURL("/images/verita-wings-symmetric-small.png");
